import { signal } from '@angular/core';
import { APP } from '../config/app';
import { IPagination } from '../store/states/pagination';
import { initialPaginationState } from '../store/initialisation/pagination';
import { IListQuery, IPaginatedList } from './paginatedList';

export class ManagementListState<T> {
  readonly items = signal<T[]>([]);
  readonly pagination = signal<IPagination>(initialPaginationState);
  readonly loading = signal(false);
  readonly searchValue = signal('');

  private latestRequestNumber = 0;

  constructor(
    private readonly fetchPage: (query: IListQuery) => Promise<IPaginatedList<T>>,
    private readonly pageSize = APP.DEFAULT_PAGE_SIZE,
  ) {}

  async load(page = this.pagination().actualPage) {
    const requestNumber = ++this.latestRequestNumber;
    this.loading.set(true);
    try {
      const result = await this.fetchPage({ search: this.searchValue(), page, size: this.pageSize });
      if (requestNumber !== this.latestRequestNumber) return;
      this.items.set(result.value);
      this.pagination.set(result.pagination);
    } finally {
      if (requestNumber === this.latestRequestNumber) this.loading.set(false);
    }
  }
}
